import type { PaymentRequest } from "@stripe/stripe-js";

/**
 * The one shipping option shown when the sheet asks for a shipping address. A
 * W3C PaymentRequest with `requestShipping` and no options tells the shopper the
 * merchant cannot ship to them, so one is required. Its amount is 0: the
 * checkout total already holds any shipping fee the merchant charges.
 */
export const DEFAULT_SHIPPING_OPTIONS = [{ id: "shipping", label: "Shipping", detail: "", amount: 0 }];

/**
 * Accept whatever shipping address the shopper picks. The sheet waits on every
 * address change for an answer; PaymentKit does not restrict where a merchant
 * ships, so the answer is always yes, with the same single option.
 */
export function acceptEveryShippingAddress(paymentRequest: PaymentRequest): void {
  paymentRequest.on("shippingaddresschange", (ev) => {
    ev.updateWith({ status: "success", shippingOptions: DEFAULT_SHIPPING_OPTIONS });
  });
}
